import { activeRoute, directionOf, tripAt, worldS } from './route';

/** Half the length of a petrol station's pump bay, metres. */
export const STATION_HALF = 9;

export interface StationPoint {
  /** 0, 1, 2… in driving order, across trips. */
  seq: number;
  name: string;
  /** World distance (metres driven) of the pump bay centre. */
  position: number;
}

/** The stations of one trip in the order you pass them (reversed on the way back). */
function stationsOfTrip(trip: number): StationPoint[] {
  const { stations } = activeRoute();
  const ordered = [...stations].sort((a, b) => (directionOf(trip) === 'out' ? a.at - b.at : b.at - a.at));
  return ordered.map((station, i) => ({ seq: trip * stations.length + i, name: station.name, position: worldS(trip, station.at) }));
}

/** Station number `seq` (counted in driving order, forever). */
export function stationAt(seq: number): StationPoint {
  const per = activeRoute().stations.length;
  const trip = Math.floor(seq / per);
  return stationsOfTrip(trip)[seq - trip * per]!;
}

/** The first station you haven't driven past yet at distance `s` (its bay still ahead, or you're in it). */
export function nextStation(s: number): StationPoint | null {
  const per = activeRoute().stations.length;
  if (per === 0) return null;
  for (let trip = tripAt(s).trip; trip < tripAt(s).trip + 2; trip += 1) {
    const found = stationsOfTrip(trip).find((station) => station.position + STATION_HALF >= s);
    if (found) return found;
  }
  return null;
}

/** Stations whose bay overlaps the stretch from..to (world metres): used to clear space for them on the street. */
export function stationsBetween(from: number, to: number): StationPoint[] {
  const first = tripAt(Math.max(0, from)).trip;
  const last = tripAt(Math.max(0, to)).trip;
  const out: StationPoint[] = [];
  for (let trip = Math.max(0, first - 1); trip <= last + 1; trip += 1) {
    for (const station of stationsOfTrip(trip)) if (station.position + 14 >= from && station.position - 14 <= to) out.push(station);
  }
  return out;
}
